import React from 'react';
import Navbar from '../Components/Navbar';
import Heroimg from '../Components/Heroimg';
import Work from '../Components/Work'
import Footer from '../Components/Footer';

const Home = () => {
  return (
    <div>
      <Navbar />
      <Heroimg />
      <Work />
      <Footer />
    </div>
  )
};

export default Home;